import { render, staticRenderFns } from "./EmployerTrainingDashboard.vue?vue&type=template&id=39f3ebdd&"
import script from "./EmployerTrainingDashboard.vue?vue&type=script&lang=ts&"
export * from "./EmployerTrainingDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports